// @ts-ignore stackedit-js ships no type declarations
import StackEditJs from 'stackedit-js'

type StackEditFile = {
  name?: string
  content?: {
    text?: string
    properties?: Record<string, unknown>
    yamlProperties?: string
  }
}

type StackEditFileChangeListener = (file: { content: { text: string } }) => void

type StackEditInstance = {
  $messageHandler: (event: MessageEvent) => void
  openFile(file?: StackEditFile, silent?: boolean): void
  close(): void
  on(type: 'fileChange', listener: StackEditFileChangeListener): void
  off(type: 'fileChange', listener: StackEditFileChangeListener): void
}

const StackEdit: new () => StackEditInstance = StackEditJs

// Message types the StackEdit iframe posts to its parent window
const STACKEDIT_MESSAGE_TYPES = ['ready', 'fileChange', 'close']

/**
 * stackedit-js closes its editor on any message coming from its iframe that isn't `ready` or
 * `fileChange`. Browser extensions running inside that iframe (e.g. password managers' inline
 * autofill) post their own messages to the parent window, which closed the editor right after it
 * opened. This subclass only lets StackEdit's own messages through.
 */
export class SafeStackEdit extends StackEdit {
  openFile(file: StackEditFile = {}, silent = false) {
    super.openFile(file, silent)

    const handleStackEditMessage = this.$messageHandler
    window.removeEventListener('message', handleStackEditMessage)

    // Stored on `$messageHandler` so StackEdit's own `close()` removes this listener
    this.$messageHandler = (event: MessageEvent) => {
      if (STACKEDIT_MESSAGE_TYPES.includes(event.data?.type)) {
        handleStackEditMessage(event)
      }
    }
    window.addEventListener('message', this.$messageHandler)
  }
}
